// What differs between the Always Cool sites; the components and site.css are shared.
export const site = {
  name: "Always Cool IO",
  legalName: "Always Cool IO",
  email: "info@alwayscool.ai",
  contact: { href: "mailto:info@alwayscool.ai", label: "Contact us" },
  footer: [
    {
      title: "Platform",
      links: [
        { href: "/#platform", label: "Tools" },
        { href: "/#companies", label: "Companies" },
        { href: "/#agents", label: "Agents" },
      ],
    },
    {
      title: "Resources",
      links: [
        { href: "/security", label: "Security" },
        { href: "/docs", label: "Documentation" },
      ],
    },
    { title: "Company", links: [{ href: "mailto:info@alwayscool.ai", label: "Email us" }] },
  ] as { title: string; links: { href: string; label: string }[] }[],
  family: [
    { name: "Always Cool Brands", href: "https://alwayscoolbrands.com" },
    { name: "Always Cool AI", href: "https://alwayscool.ai" },
  ] as { name: string; href: string }[],
  menu: undefined as { label: string; href: string; items: { href: string; label: string; text: string }[] } | undefined,
  nav: [
    { href: "/#platform", label: "Platform" },
    { href: "/#companies", label: "Companies" },
    { href: "/#agents", label: "Agents" },
  ],
};
